class HamburgerMenu {
  constructor({
    dom,
    closePrimaryNavChildMenu
  }) {

    this.dom = {
      ...dom,
      $trigger: dom.$header._$$('.hamburger-menu-items__trigger'),
      $close: dom.$header._$('.hamburger-menu .header__back-to-top-level-trigger'),
      $menus: dom.$header._$$('.hamburger-menu__child-menu')
    }

    this.closePrimaryNavChildMenu = closePrimaryNavChildMenu;
    this.openedClass = 'header--hamburger-menu-opened';
    this.currentChildMenuClass = 'hamburger-menu__child-menu--current';

    this.addListeners();
  }

  addListeners() {
    this.dom.$trigger.forEach((el, i) => el._on('click', () => this.open(i)));
    this.dom.$close._on('click', this.close.bind(this));
  }

  open(index) {
    this.dom.$header.classList.add(this.openedClass);
    this.dom.$menus.forEach(x => x.classList.remove(this.currentChildMenuClass));
    this.dom.$menus[index].classList.add(this.currentChildMenuClass);
  }

  close() {
    this.dom.$header.classList.remove(this.openedClass);
  }
}

export default HamburgerMenu;
